import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${props => props.fullScreen ? 1500 : 1200};
`;

const ModalContent = styled.div`
  background-color: ${props => props.fullScreen ? 'transparent' : 'white'};
  padding: ${props => props.fullScreen ? '0' : '2rem'};
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: ${props => props.fullScreen ? '100vw' : '90vw'};
  max-height: ${props => props.fullScreen ? '100vh' : '90vh'};
`;

const Modal = ({ children, onClose, fullScreen }) => {
  return (
    <ModalOverlay onClick={onClose} fullScreen={fullScreen}>
      <ModalContent onClick={e => e.stopPropagation()} fullScreen={fullScreen}>
        {children}
      </ModalContent>
    </ModalOverlay>
  );
};

export default Modal;